import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'gl-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    standalone: false
})
export class MenuItemComponent {
  @HostBinding('class.active') @Input() public active: boolean;

}
